<template>
  <div class="message_box" :style="{ zIndex:zIndex }">
    <div class="message_content" :style="{ width: options.widths + 'px' }">
      <div class="msg_title" style="position: relative">
        <i class="el-icon-close" style="cursor:pointer;" @click="close"></i>
        <span>{{ options.title }}</span>
      </div>
      <div class="msg_content" v-if="options.type == 1" style="
          text-align: center;
          font-size: 20px;
          color: #333;
        ">
        <i class="el-icon-warning" style="color: #f56c6c; margin-right: 5px"></i>{{ options.contents }}
      </div>
      <!-- <div>
        <slot name="msgbox_examine"></slot>
      </div> -->
      <div class="msg_content" :style="{ height: options.height + 'px' }" v-if="options.type == 2 || options.type == 4">
        <slot />
      </div>

      <div class="msg_contents" v-if="options.type == 3">
        {{ options.contents }}
      </div>
      <div>
        <slot name="msgbox_slot"></slot>
      </div>
      <div class="msg_bottom" v-if="options.type != 4">
        <el-button  @click="cancel">{{ button.cancel }}</el-button>
        <el-button type="danger" @click="comfirm">{{ button.sure }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    components: {},
    data() {
      return {};
    },
    props: {
      options: {
        type: Object,
        default: () => {
          return {}
        }
      },
      zIndex: {
        type: Number,
        default: 99
      },
      button: {
        type: Object,
        default: () => {
          return {
            cancel: "取消",
            sure: "确定"
          }
        }
      }
    },
    methods: {
      close() {
        this.options.callback.close()
      },
      comfirm() {
        this.options.callback.comfirm()
      },
      cancel() {
        this.options.callback.cancel()
      },
    },
  };
</script>
<style lang="less" scoped>
  @import url("../../assets/css/common.less");

  .message_box {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .msg_content {
    box-sizing: border-box;
    padding: 20px;
    overflow: auto;
  }

  .message_content {
    border-radius: 10px;
    background: #fff;
    animation: movetop 0.3s linear;
    display: flex;
    flex-direction: column;
    max-height: 650px;
  }

  .msg_bottom {
    padding: 15px;
    text-align: center;
  }

  .showit {
    animation: movetop 0.3s linear;
  }

  @keyframes movetop {
    from {
      margin-top: -100px;
      opacity: 0;
    }

    to {
      margin-top: 0px;
      opacity: 1;
    }
  }

  @keyframes movetopback {
    from {
      margin-top: 0px;
      opacity: 1;
    }

    to {
      margin-top: -100px;
      opacity: 0;
    }
  }

  .msg_title {
    width: 100%;
    padding: 5px 0;
    background: linear-gradient(to right, #f65353, #fe8e8e);
    text-align: center;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    span {
      display: block;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 2px;
    }
  }

  .el-icon-close {
    margin-right: 20px;
    color: #fff;
    font-size: 20px;
    vertical-align: middle;
    position: absolute;
    right: 3px;
    top: 50%;
    transform: translate(0, -50%);
  }

  .msg_main {
    min-height: 200px;
    display: flex;
    align-items: center;
    background-color: #fff;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .main_text {
    font-size: 21px;
    color: #000000;
  }

  .option_box {
    display: flex;
    justify-content: space-around;
    margin-top: 30px;
  }

  .nocenter {
    display: inherit;
  }

  .msg_contents {
    text-align: center;
    font-size: 16px;
    color: rgb(51, 51, 51);
    padding: 30px 0px;
    width: 80%;
    margin: 0 auto;
    line-height: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MessageBox/index.vue